import { Routes } from '@angular/router';
import { PUBLIC_ROUTES } from './routes/public.routes';

export const APP_ROUTES: Routes = [
   ...PUBLIC_ROUTES,
   {
      path: '',
      loadChildren: () => import('./routes/shell.routes').then((module) => module.SHELL_ROUTES),
   },
];
